import { IDiscountRepository } from '../domain/IDiscountRepository'

export class DownloadMetaDiscountAssociations {
  constructor(public readonly discountRepository: IDiscountRepository) {}

  async execute(reference: string, participants: number[]): Promise<void> {
    return this.discountRepository.downloadMetaDiscountAssociations(reference, participants)
  }
}
